// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.230",
  "gitHash": "8312bbe4f8954f2c83f7ea9c4c3ef4038f251f8d",
  "versionWithHash": "5.5.230-8312bbe4f8954f2c83f7ea9c4c3ef4038f251f8d"
};
